import { getConfig } from './config'

export type Exam = {
  _id: string;
  updatedAt: Date;
  createdAt: Date;
  name: string;
  lab: string;
  existsReferenceValue: boolean;
  normalizedExam: string;
  defaultMeasurement: string;
  material?: string;
  measurements: string[];
}

export type ExamParams = {
  select?: 'byRules'
}

export const get = async (params?: ExamParams): Promise<Exam[]> => {
  const config = getConfig()

  const url = `${config.API_URL}/exams`

  const response = await config.axios.get<Exam[]>(url, { params })

  return response.data
}
